<template>
  <div>
    <h5 class="card-title">
      <i class="fas fa-bell"></i>
      Movimentações não visualizadas
    </h5>

    <div v-if="loading" class="text-center">
      <b-spinner small></b-spinner>
      <span class="ml-2">Carregando...</span>
    </div>
    <div
      v-else-if="
        filterNotifications(
          NotificationType.NEW_COMPLAINT_EVENT,
          NotificationType.NEW_RESPONSE
        ).length === 0
      "
      class="text-muted text-center"
    >
      <i class="fas fa-check-circle"></i>
      Nenhuma movimentação não visualizada encontrada
    </div>
    <div v-else>
      <div class="mb-3">
        <div>
          <b-badge variant="secondary" class="mr-2">
            Total:
            {{
              filterNotifications(
                NotificationType.NEW_COMPLAINT_EVENT,
                NotificationType.NEW_RESPONSE
              ).length
            }}
          </b-badge>
          <small class="text-muted"
            >movimentações aguardando visualização</small
          >
        </div>
      </div>

      <div class="notifications-list-container">
        <div class="notifications-header">
          <div class="row-content">
            <div class="protocol-section header-label">PROTOCOLO</div>
            <div class="date-section header-label">DATA DE CRIAÇÃO</div>
            <div class="count-section header-label">QUANTIDADE</div>
            <div class="actions-section header-label">AÇÃO</div>
          </div>
        </div>
        <div class="notifications-scroll">
          <div class="notifications-list">
            <div
              v-for="notification in filterNotifications(
                NotificationType.NEW_COMPLAINT_EVENT,
                NotificationType.NEW_RESPONSE
              )"
              :key="notification._id"
              class="notification-row"
              @click="openNotification(notification)"
            >
              <div class="row-content">
                <div class="protocol-section">
                  <strong class="protocol-link">{{
                    notification.complaint.protocol
                  }}</strong>
                </div>

                <div class="date-section">
                  <span class="date-text">{{
                    notification.createdAt | datetime
                  }}</span>
                </div>

                <div class="count-section">
                  <b-badge pill variant="secondary">{{
                    notification.count
                  }}</b-badge>
                </div>

                <div class="actions-section">
                  <i class="fas fa-external-link-alt action-icon"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNotifications } from "../../api/notifications";
import NotificationType from "../../../../backend/models/NotificationType.ts";

export default {
  name: "UnreadMovementsCard",
  props: {
    company: {
      type: [Number, String],
      default: undefined,
    },
  },
  data() {
    return {
      notifications: [],
      NotificationType,
      loading: true,
    };
  },
  watch: {
    company() {
      this.loadNotifications();
    },
  },
  async created() {
    await this.loadNotifications();
  },
  methods: {
    async loadNotifications() {
      this.loading = true;
      const response = await getNotifications(this.company, "complaint");
      const notifications = response.data;

      const notificationsGrouped = {};

      for (const notification of notifications) {
        const gid = `${notification.complaint._id}|${notification.type}`;
        notificationsGrouped[gid] = notificationsGrouped[gid] || [];
        notificationsGrouped[gid].push(notification);
      }
      const grouped = [];
      for (const gid of Object.keys(notificationsGrouped)) {
        const nots = notificationsGrouped[gid];
        nots.sort((a, b) => b._id - a._id);
        const first = nots[0];
        grouped.push({
          _id: first._id,
          type: first.type,
          createdAt: first.createdAt,
          complaint: first.complaint,
          dsar: first.dsar,
          ombudsman: first.ombudsman,
          count: nots.length,
        });
      }
      grouped.sort((a, b) => b._id - a._id);
      this.notifications = grouped;

      this.loading = false;
    },
    filterNotifications(...types) {
      return this.notifications.filter((n) => types.includes(n.type));
    },
    openNotification(notification) {
      this.$router.push(`/denuncias/${notification.complaint._id}`);
    },
  },
};
</script>

<style scoped>
.card-title {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #495057;
}

.card-title .fas {
  margin-right: 8px;
  color: #6c757d;
}

.notifications-list-container {
  border: 1px solid #e9ecef;
  border-radius: 4px;
  overflow: hidden;
}

.notifications-header {
  background-color: #f8f9fa;
  border-bottom: 2px solid #e9ecef;
  padding: 0.75rem 1rem;
}

.header-label {
  font-weight: 600;
  color: #495057;
  font-size: 0.8rem;
  text-transform: uppercase;
}

.notifications-scroll {
  max-height: 250px;
  overflow-y: auto;
}

.notifications-list {
  padding: 0;
}

.notification-row {
  border-bottom: 1px solid #f1f3f4;
  padding: 0.75rem 1rem;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.notification-row:hover {
  background-color: #f8f9fa;
}

.notification-row:last-child {
  border-bottom: none;
}

.row-content {
  display: grid;
  grid-template-columns: 2fr 1.5fr 1fr 0.5fr;
  align-items: center;
  gap: 1rem;
}

.protocol-section,
.date-section,
.count-section,
.actions-section {
  display: flex;
  align-items: center;
}

.actions-section {
  justify-content: center;
}

.protocol-link {
  color: #007bff;
  font-weight: 500;
}

.date-text {
  color: #6c757d;
}

.action-icon {
  color: #6c757d;
  transition: color 0.2s;
}

.notification-row:hover .action-icon {
  color: #007bff;
}

@media (max-width: 992px) {
  .row-content {
    grid-template-columns: 1.5fr 1fr 0.8fr 0.5fr;
    gap: 0.5rem;
  }

  .header-label {
    font-size: 0.7rem;
  }
}
</style>
